const SingleFamilyContractDetails = ({
  customerId = '',
  name = '',
  unitCost = null,
  unitOfMeasure = '',
  productType = null,
} = {}) => ({
  customerId: String(customerId),
  name: String(name),
  unitCost: Number(unitCost),
  unitOfMeasure: String(unitOfMeasure),
  productType: String(productType),
});

export default SingleFamilyContractDetails;

export type SingleFamilyContractDetailsProps = ReturnType<typeof SingleFamilyContractDetails>;
